<lib-identity-form #identityForm>
  @if (showEntityTabs) {
    <div class="tabs-region" slot="tabs-slot" [class.overlay-active]="activeTab !== 'overview'">
      <div class="tab-nav" role="tablist">
        <a role="tab" class="tab" [routerLink]="['/identities', entityId, 'overview']" [replaceUrl]="true" routerLinkActive="active">Overview</a>
        <a role="tab" class="tab" [routerLink]="['/identities', entityId, 'events']" [replaceUrl]="true" routerLinkActive="active">Events</a>
        <a role="tab" class="tab" [routerLink]="['/identities', entityId, 'metrics']" [replaceUrl]="true" routerLinkActive="active">Metrics</a>
        <a role="tab" class="tab" [routerLink]="['/identities', entityId, 'dial-logs']" [replaceUrl]="true" routerLinkActive="active">Dial Logs</a>
        <a role="tab" class="tab" [routerLink]="['/identities', entityId, 'visualizer']" [replaceUrl]="true" routerLinkActive="active">Visualizer</a>
      </div>
      @if (activeTab === 'events') {
        <div class="entity-tab-panel">
          <app-events-tab [data]="entityTabData"></app-events-tab>
        </div>
      }
      @if (activeTab === 'metrics') {
        <div class="entity-tab-panel">
          <app-metrics-tab [data]="entityTabData"></app-metrics-tab>
        </div>
      }
      @if (activeTab === 'dial-logs') {
        <div class="entity-tab-panel dial-logs-panel">
          <app-dial-logs-timeline-tab [data]="entityTabData"></app-dial-logs-timeline-tab>
        </div>
      }
      @if (activeTab === 'visualizer') {
        <div class="entity-tab-panel visualizer-panel">
          <netfoundry-ui-identity-visualizer-tab [data]="entityTabData"></netfoundry-ui-identity-visualizer-tab>
        </div>
      }
    </div>
  }
  @if ((hasEnrollmentJwt && !enrollmentExpired) || showConflictBanner) {
    <div slot="column-2-slot-1" class="share-identity-container">
      @if (showConflictBanner) {
        <lib-form-field-container [showHeader]="false">
          <div
            class="conflict-container"
            [matTooltip]="attributeConflictWarning ? getAttributeConflictTooltip(attributeConflictWarning) : ''"
            matTooltipShowDelay="150"
            [class.clickable]="!attributeConflictWarning?.resolvesExistingConflict"
            [class.resolved]="attributeConflictWarning?.resolvesExistingConflict"
            (click)="openConflictDetailsModal($event)"
          >
            <div class="conflict-content">
              <div class="conflict-main-row">
                <div class="conflict-icon icon-Network-Failure"></div>
                <span>
                  {{ conflictBannerMessage }}
                </span>
              </div>
              @if (!attributeConflictWarning?.resolvesExistingConflict) {
                <button
                  type="button"
                  class="conflict-more-info-link"
                  (click)="openConflictDetailsModal($event)"
                >
                  Click for details...
                </button>
              }
            </div>
          </div>
        </lib-form-field-container>
      }
      @if (!useStrictReadonlyForm) {
      <lib-form-field-container [showHeader]="false">
        <div class="share-identity-container">
          <span class="info-text">SHARE THIS IDENTITY</span>
          <div class="download-button share-button" (click)="svc.shareRegistration(svc.formData)">
            <div class="icon-email"></div>
            <div>SEND REGISTRATION EMAIL</div>
            <div class="icon-Icon_Share"></div>
          </div>
        </div>
      </lib-form-field-container>
      }
    </div>
  }
  @if (jwtBasedAuthUrl && showJwtBasedAuth) {
    <div slot="column-1-slot-1" class="share-identity-container">
      <lib-form-field-container
        [title]="'Controller URL For OIDC Authentication'"
        [contentStyle]="'z-index: 10002'"
        >
        <div class="copy-link-container">
          <span class="read-only" [disabled]="true" (click)="copyPublicDomainUrl()">{{ jwtBasedAuthUrl }}</span>
          <div class="copy-button" (click)="copyPublicDomainUrl()"></div>
        </div>
      </lib-form-field-container>
    </div>
  }
</lib-identity-form>
